import { PropsWithChildren } from "react";
import { useIntl } from "react-intl";
import Helmet from "react-helmet";

import {useTranslation} from '../../translation/TranslationContext'
import { defaultLocaleCodes, languageConfig } from "../../../translations/config";
import { usePathname } from "../../../routeConfig";

interface Props extends PropsWithChildren<{}> {
  titleTranslation?: string
  descriptionTranslation?: string
}

export default function Page({ titleTranslation, descriptionTranslation, children }: Props) {
  const intl = useIntl();
  const {selectedLanguage} = useTranslation()
  const origin = window.location.origin
  const pathname = usePathname()

  return (
    <>
      <Helmet>
        <html lang={selectedLanguage} />
        <title>{intl.formatMessage({ id: titleTranslation || 'page.home.title' })}</title>
        <meta name="description" content={intl.formatMessage({ id: descriptionTranslation || 'page.home.description' })} />
        <link rel="canonical" href={`${origin}/${defaultLocaleCodes.others}${pathname}`} />
        <link rel="alternate" href={`${origin}/pt-PT${pathname}`} hrefLang="pt" />
        <link rel="alternate" href={`${origin}/en-GB${pathname}`} hrefLang="en" />

        {languageConfig.map(({ localeCode }) => (
          <link key={localeCode} rel="alternate" href={`${origin}/${localeCode}${pathname}`} hrefLang={localeCode} />
        ))}
      </Helmet>

      {children}
    </>
  )
}
